import { render } from "./DataCenter.vue?vue&type=template&id=60550646&scoped=true"
import script from "./DataCenter.vue?vue&type=script&lang=js"
export * from "./DataCenter.vue?vue&type=script&lang=js"

import "./DataCenter.vue?vue&type=style&index=0&id=60550646&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-60550646"

export default script